import { createAction, props } from '@ngrx/store';
import { CommonFilters } from '../models/Args';
import { FiltersState } from './common-filters.reducer';

export const updateState = createAction(
    '[COMMON FILTERS] Update state',
    props<{ filtersState: FiltersState; }>()
);
